import { render, staticRenderFns } from "./BlindReviewsPage.vue?vue&type=template&id=96e458fa&scoped=true"
import script from "./BlindReviewsPage.vue?vue&type=script&lang=js"
export * from "./BlindReviewsPage.vue?vue&type=script&lang=js"
import style0 from "./BlindReviewsPage.vue?vue&type=style&index=0&id=96e458fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e458fa",
  null
  
)

export default component.exports